"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSingleParamValue = exports.getFirstParamValueAsSet = exports.getParamValuesAsSet = exports.setParamValues = exports.removeParamValue = exports.addParamValue = exports.paramValuesMapToSearch = exports.searchToParamValuesMap = void 0;
const data_structures_1 = require("@tableau/data-structures");
function searchToParamValuesMap(search) {
    const paramValuesMap = {};
    if (search.length > 0) {
        if (search[0] === '?') {
            search = search.slice(1);
        }
        const clauses = search.split('&');
        for (const clause of clauses) {
            const parts = clause.split('=');
            if (parts.length > 0) {
                const param = decodeURIComponent(parts[0]);
                paramValuesMap[param] = parts[1] ? parts[1].split(',').map(decodeURIComponent) : [];
            }
        }
    }
    return paramValuesMap;
}
exports.searchToParamValuesMap = searchToParamValuesMap;
function paramValuesMapToSearch(paramValuesMap) {
    const searchClauses = [];
    for (const param in paramValuesMap) {
        if (Object.prototype.hasOwnProperty.call(paramValuesMap, param)) {
            const encodedParam = encodeURIComponent(param);
            const values = paramValuesMap[param];
            if (values && values.length > 0) {
                searchClauses.push(`${encodedParam}=${values.join(',')}`);
            }
            else {
                searchClauses.push(encodedParam);
            }
        }
    }
    if (searchClauses.length > 1) {
        return `?${searchClauses.join('&')}`;
    }
    else if (searchClauses.length === 1) {
        return `?${searchClauses[0]}`;
    }
    else {
        return '';
    }
}
exports.paramValuesMapToSearch = paramValuesMapToSearch;
function addParamValue(paramValuesMap, param, value, encode = true) {
    const values = paramValuesMap[param];
    if (encode) {
        value = encodeURIComponent(value);
    }
    if (!values) {
        paramValuesMap[param] = [value];
    }
    else {
        if (values.indexOf(value) === -1) {
            paramValuesMap[param] = [...values, value];
        }
    }
}
exports.addParamValue = addParamValue;
function removeParamValue(paramValuesMap, param, value) {
    const values = paramValuesMap[param];
    if (values) {
        paramValuesMap[param] = values.filter(v => v !== value);
        if (paramValuesMap[param].length === 0) {
            delete paramValuesMap[param];
        }
    }
}
exports.removeParamValue = removeParamValue;
function setParamValues(paramValuesMap, param, values, encode = true) {
    if (encode) {
        values = values.map(encodeURIComponent);
    }
    paramValuesMap[param] = values;
    if (paramValuesMap[param].length === 0) {
        delete paramValuesMap[param];
    }
}
exports.setParamValues = setParamValues;
function getParamValuesAsSet(search, param) {
    const paramValuesMap = searchToParamValuesMap(search);
    return (0, data_structures_1.stringListToKeySet)(paramValuesMap[param]);
}
exports.getParamValuesAsSet = getParamValuesAsSet;
// Only take the first id for the param until Multi-Select Filtering is supported
function getFirstParamValueAsSet(search, param) {
    const firstParamValue = getSingleParamValue(search, param);
    return (0, data_structures_1.stringListToKeySet)(firstParamValue ? [firstParamValue] : []);
}
exports.getFirstParamValueAsSet = getFirstParamValueAsSet;
function getSingleParamValue(search, param) {
    const paramValuesMap = searchToParamValuesMap(search);
    return paramValuesMap[param] ? paramValuesMap[param][0] : '';
}
exports.getSingleParamValue = getSingleParamValue;
//# sourceMappingURL=UrlSearchFunctions.js.map